var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    disabled: _vm.disabled,
    selected: _vm.localValue,
    'select-box text-center': true,
  },attrs:{"role":"checkbox","aria-checked":_vm.localValue},on:{"click":_vm.toggleChecked}},[(_vm.value)?_c('v-icon',{staticClass:"mb-1",attrs:{"size":"15","color":"white"}},[_vm._v("\n    fas fa-check\n  ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }